import React, { useEffect } from "react";
import { Box, CircularProgress } from "@mui/material";
import { saveCampaignUrlCapture } from "../utils/api";

const WHATSAPP_REDIRECT_URL = "https://wa.me/5511947273925";
const PRIMARY_GREEN = "#13B497";
const SAVE_TIMEOUT_MS = 5000;

function extractUrlParameters(): Record<string, string> {
	const parameters: Record<string, string> = {};
	const searchParams = new URLSearchParams(window.location.search);

	searchParams.forEach((value, key) => {
		parameters[key] = value;
	});

	return parameters;
}

export default function CampaignRedirectPage() {
	useEffect(() => {
		let cancelled = false;

		const redirectToWhatsApp = () => {
			if (!cancelled) {
				window.location.replace(WHATSAPP_REDIRECT_URL);
			}
		};

		const captureAndRedirect = async () => {
			const parameters = extractUrlParameters();
			const controller = new AbortController();
			const timeoutId = window.setTimeout(() => controller.abort(), SAVE_TIMEOUT_MS);

			try {
				await saveCampaignUrlCapture(
					{
						parameters,
						fullUrl: window.location.href,
					},
					controller.signal
				);
			} catch {
				// Redirect even when the backend call fails.
			} finally {
				window.clearTimeout(timeoutId);
				redirectToWhatsApp();
			}
		};

		captureAndRedirect();

		return () => {
			cancelled = true;
		};
	}, []);

	return (
		<Box
			sx={{
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				minHeight: "100vh",
				bgcolor: "#fff",
			}}
		>
			<CircularProgress sx={{ color: PRIMARY_GREEN }} />
		</Box>
	);
}
